// =========================================================
// BIG-Slider – Center Mode Infinite Carousel
// =========================================================

document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('[data-big-slider]');
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const viewport = slider.querySelector('[data-viewport]');
    const track = slider.querySelector('[data-track]');
    const prevBtn = slider.querySelector('[data-prev]');
    const nextBtn = slider.querySelector('[data-next]');
    const dotsContainer = slider.querySelector('[data-dots]');

    if (!viewport || !track) return;

    let slides = Array.from(track.children);
    const originalCount = slides.length;
    if (originalCount === 0) return;

    const autoplay = slider.dataset.autoplay === 'true';
    const interval = parseInt(slider.dataset.interval, 10) || 5000;
    let timer = null;

    // -----------------------------
    // クローン作成（無限ループ用）
    // -----------------------------
    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[originalCount - 1].cloneNode(true);

    firstClone.classList.add('is-clone');
    lastClone.classList.add('is-clone');

    track.appendChild(firstClone);
    track.insertBefore(lastClone, slides[0]);

    slides = Array.from(track.children);

    // index:
    //  0           → lastClone
    //  1..n        → 本物
    //  n+1         → firstClone
    let index = 1; // 最初は1番目の本スライドを中央に

    // -----------------------------
    // ドット生成
    // -----------------------------
    const dots = [];
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      for (let i = 0; i < originalCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'BIG-Slider__Dot';
        dot.addEventListener('click', () => {
          index = i + 1; // クローン分 +1
          updatePosition(true);
          restartAutoplay();
        });
        dotsContainer.appendChild(dot);
        dots.push(dot);
      }
    }

    function updateDots() {
      if (!dots.length) return;
      const realIndex = (index - 1 + originalCount) % originalCount;
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === realIndex);
      });
    }

    // -----------------------------
    // 位置計算
    //  - SP: スライド幅 ≒ ビューポート幅 → 1枚ぴったり
    //  - PC: スライド幅 70%、viewport幅100% → 両端が覗く
    // -----------------------------
    function getDims() {
      const viewportRect = viewport.getBoundingClientRect();
      // クローンではなく本物を基準に幅を取る
      let baseSlide = slides.find((sl) => !sl.classList.contains('is-clone')) || slides[0];
      const slideRect = baseSlide.getBoundingClientRect();

      return {
        viewportWidth: viewportRect.width || 1,
        slideWidth: slideRect.width || viewportRect.width || 1
      };
    }

    function updatePosition(animate = true) {
      const { viewportWidth, slideWidth } = getDims();

      const isPC = window.innerWidth >= 1024;

      // margin-right を含めた実際の占有幅を取得
      const computedStyle = window.getComputedStyle(slides[0]);
      const marginRight = parseFloat(computedStyle.marginRight) || 0;
      const totalWidth = slideWidth + marginRight;

      let offset = 0;

      if (isPC) {
        /* ==============================
          PC：既存の CenterMode 計算
          ============================== */
        const centerOffset = (viewportWidth - slideWidth) / 2;
        offset = slideWidth * index - centerOffset;

      } else {
        /* ==============================
          SP：1枚100%で正確な中央へ
          ズレの原因 → clone を含めた width 計算が不足
          ============================== */
        offset = totalWidth * index;
      }

      track.style.transition = animate ? 'transform 0.4s ease' : 'none';
      track.style.transform = `translateX(${-offset}px)`;

      track.addEventListener('transitionend', onTransitionEnd, { once: true });
      updateDots();
    }

    // クローンを踏んだら本体にワープ
    function onTransitionEnd() {
      if (slides[index].classList.contains('is-clone')) {
        track.style.transition = 'none';

        if (index === 0) {
          // 左端のクローン → 最後の本スライドへ
          index = originalCount;
        } else if (index === slides.length - 1) {
          // 右端のクローン → 1枚目の本スライドへ
          index = 1;
        }

        updatePosition(false);
      }
    }

    // -----------------------------
    // ナビゲーション
    // -----------------------------
    function next() {
      index++;
      updatePosition(true);
    }

    function prev() {
      index--;
      updatePosition(true);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prev();
        restartAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        next();
        restartAutoplay();
      });
    }

    // -----------------------------
    // オートプレイ
    // -----------------------------
    function startAutoplay() {
      if (!autoplay || originalCount <= 1) return;
      stopAutoplay();
      timer = setInterval(next, interval);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    // リサイズ時も中央位置を再計算
    window.addEventListener('resize', () => {
      updatePosition(false);
    });

    // 初期化
    updatePosition(false);
    startAutoplay();
  });
});